import { getAnnouncementDetail, getAnnouncementList, updateAnnouncementList } from 'containers/OutBidding/api';
import { Spin } from '@bedrock/components';
import { getListPathMenuKey } from 'containers/OutBidding/utils';
import React, { useEffect } from 'react'
import { useOpenBiddingModal } from '@mpc/common/src/features/BiddingModal/index';
import isBlank from 'utils/object';
import { refreshList } from 'modules/actions/smProjectMove';
import { connect } from 'react-redux';
import { bindActionCreators, Dispatch } from 'redux';

const NewAnnouncementModal = (props: any) => {
    const [loading, setLoading] = React.useState(false);
    const refresh = () => {
        // 如果已在列表弹框, 则刷新
        if (['toDoProcess'].includes(getListPathMenuKey())) {
            refreshList(getListPathMenuKey());
        }
    };

    const { id } = props;
    const { openBiddingModal, destroy } = useOpenBiddingModal({
        updateAnnouncementList,
        refresh,
        id,
        isList: false,
        onClose: props?.onClose
    })


    const getDetail = async () => {
        const res = await getAnnouncementDetail(id).catch(() => {
            refresh();
        });
        const { data } = res;
        openBiddingModal([data])
    };

    useEffect(() => {
        if (id) {
            setLoading(true);
            getDetail().finally(() => {
                setLoading(false);
            });
        }
    }, [id]);


    return (
        <>
            { loading && <Spin.Global spinning={loading} /> }
        </>
    );
}


export function mapDispatchToProps(dispatch: Dispatch<any>, ownProps: any) {
    return bindActionCreators(
        {
            refreshList,
        },
        dispatch
    );
}

export default connect(null, mapDispatchToProps)(NewAnnouncementModal);